import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const recipientAddressValidator = v.object({
  label: v.string(),
  street: v.string(),
  city: v.string(),
  state: v.string(),
  country: v.string(),
  zipCode: v.optional(v.string()),
  mapUrl: v.optional(v.string()),
  notes: v.optional(v.string()),
});

export const validatorRecipient = v.object({
  clientId: v.id("clients"), // Cliente dueño/remitente
  name: v.string(),
  phone: v.optional(v.string()),
  phone2: v.optional(v.string()),
  email: v.optional(v.string()),
  addresses: v.optional(v.array(recipientAddressValidator)),
  notes: v.optional(v.string()),
  isActive: v.optional(v.boolean()),
  internalControl: internalControl,
});

export const recipients = defineTable(validatorRecipient)
  .index("by_client", ["clientId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_company_and_client", ["internalControl.companyId", "clientId"])
  .index("by_client_and_active", ["clientId", "isActive"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .searchIndex("search_recipients", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "clientId",
      "isActive",
    ],
  });
